export default __webpack_public_path__ + "static/media/maestro.7a99cc94.svg";